__turbopack_context__.v({
  "notifications": "Notifications-module__ejXYoq__notifications",
  "notifications__header": "Notifications-module__ejXYoq__notifications__header",
});
